import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { getInsertIndex } from '../tools/edit/get-insert-index';
import { ShapeHelper } from './shape-helper';

export class LineHelper extends ShapeHelper {
  override allowsSubpointSelection = true;
  override allowsAddingAndRemovingSubpoints = true;

  override getInsertIndex(oldPoints: Point2D[], newPoint: Point2D) {
    return getInsertIndex(oldPoints, newPoint, false);
  }

  override getMinPoints() {
    return 2;
  }
}
